import { HistoryMode } from "src/clients/flow-api";
import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";
import { useWorkspaceContext } from "src/router/routerContextHooks";

/**
 * Hook to determine if Iceberg (Decision History v2) should be used
 *
 * Returns true if either:
 * - The readDHv2 feature flag is enabled, OR
 * - The workspace history_mode is ICEBERG_READ_ICEBERG
 *
 * Use this hook in any component that needs to read from Decision History v2
 * (e.g., performance dashboard, decision history views, analytics)
 */
export const useIsIcebergEnabled = (): boolean => {
  const { workspace } = useWorkspaceContext();
  const featureFlagEnabled = isFeatureFlagEnabled(FEATURE_FLAGS.readDHv2);
  const isIcebergOnly =
    workspace.config?.history_mode === HistoryMode.ICEBERG_READ_ICEBERG;

  return featureFlagEnabled || isIcebergOnly;
};
